import React, { useCallback } from 'react';
import {
    CaretDownOutlined,
    useBreakpoint,
    Popover,
    Button,
    Flex,
    Box,
} from '@landr/maestro';
import { BpmControl } from 'components/Creator/BpmControl';
import { BpmControlPopoverProps } from './BpmControlPopover.types';

export const BpmControlPopover = ({
    bpm,
    onApply,
    isDisabled = false,
}: BpmControlPopoverProps): JSX.Element => {
    const handleApply = useCallback(
        (newBpm: number): void => {
            onApply(newBpm);
        },
        [onApply],
    );

    const isMobile = useBreakpoint('md');

    return (
        <Popover placement="top-end">
            {({ close }): JSX.Element => (
                <>
                    <Popover.Trigger>
                        <Button
                            variant="ghost"
                            isRounded
                            size="sm"
                            isDisabled={isDisabled}
                            iconRight={() =>
                                isMobile ? undefined : (
                                    <CaretDownOutlined
                                        color="icon.low"
                                        size="sm"
                                    />
                                )
                            }
                        >
                            <Flex>
                                {bpm}
                                <Box marginLeft="0.25em" hideBelow="350px">
                                    bpm
                                </Box>
                            </Flex>
                        </Button>
                    </Popover.Trigger>
                    <Popover.Content py="none" px="none">
                        <BpmControl
                            onApply={handleApply}
                            initialBpm={bpm}
                            onClick={close}
                        />
                    </Popover.Content>
                </>
            )}
        </Popover>
    );
};
